<template lang="pug">
  b-button.add-element-button(variant="soft-info", :block="block", @click="$emit('click')")
    .d-flex.align-items-center.justify-content-center.text-sm.text-secondary
      span {{ title }}
      plus-icon.icon-sm.ml-1
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Agregar elemento'
    },
    block: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
